<mx-base-dialog [definition]="baseDialogDefinition"
                [closeOnConfirm]="closeOnConfirm"
                [showCancelButton]="showCancelButton"
                [enableCancelButton]="enableCancelButton"
                [showConfirmButton]="showConfirmButton"
                [enableConfirmButton]="enableConfirmButton && (hasChanged(formGroup) || allowConfirmWhenPristine) && (formGroup.valid || formGroup.pending)"
                [showAdditionalActionButtons]="showAdditionalActionButtons"
                [additionalButtonsAreConfirm]="additionalButtonsAreConfirm"
                [confirmationPending]="confirmationPending"
                [showConfirmationPendingSpinner]="showConfirmationPendingSpinner">
  <!-- The contents of a basic form dialog are the same as the contents of a split form dialog's section, so delegate to that component. -->
  <mx-split-form-dialog-section [formGroup]="formGroup" [delegateVerticalScrolling]="delegateVerticalScrolling">
    <ng-container aboveForm>
      <ng-content select="[aboveForm]"/>
    </ng-container>

    <div class="flex flex-col gap-y-5">
      <ng-content/>
    </div>

    <ng-container belowForm>
      <ng-content select="[belowForm]"/>
    </ng-container>
  </mx-split-form-dialog-section>

  <ng-container additionalActionButtons>
    <ng-content select="[additionalActionButtons]"/>
  </ng-container>
</mx-base-dialog>
